var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100 h-100 d-flex flex-column justify-space-between"},[_c('div',{staticClass:"mx-auto"},[_vm._v("Moinaaas")]),_c('twitch-player',{staticClass:"mx-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }